
import { reactive, ref, onMounted } from "vue";
import { sysUserCustomerUpdate } from "@/api/api";
import type { FormInstance } from "ant-design-vue";
import { getUserInfo, setUserInfo } from "@/utils/auth";
import { message } from "ant-design-vue";

export default {
  setup() {
    const contactFormRef = ref<FormInstance>();
    const contactFormState = reactive({
      remark: "",
    });
    const contactLoading = ref(false);

    // 从缓存加载用户信息
    const loadUserInfo = () => {
      const userInfo = getUserInfo();
      if (userInfo && userInfo.remark) {
        contactFormState.remark = userInfo.remark;
      }
    };

    // 组件挂载时加载用户信息
    onMounted(() => {
      loadUserInfo();
    });

    const confirmContact = async () => {
      try {
        contactLoading.value = true;
        // 只传 remark
        const updateData = {
          remark: contactFormState.remark,
        };
        sysUserCustomerUpdate(updateData).then((res) => {
          contactLoading.value = false;
          if (res.code === "200") {
            // 更新用户信息缓存
            const currentUserInfo = getUserInfo();
            if (currentUserInfo) {
              // 创建新对象，确保更新成功
              const updatedUserInfo = {
                ...currentUserInfo,
                remark: contactFormState.remark,
              };
              setUserInfo(updatedUserInfo);
              message.success("保存成功");
            } else {
              console.warn("用户信息不存在，无法更新缓存");
            }
          }
        });
      } catch (errorInfo) {
        contactLoading.value = false;
        console.log("Failed:", errorInfo);
      }
    };

    return {
      contactFormState,
      contactFormRef,
      contactLoading,
      confirmContact,
      loadUserInfo,
    };
  },
};
